'use strict';

angular.module('imagetrend.components')
    .directive('hlpFormField', ['$injector', '$rootScope', '$templateCache', '$timeout', 'Format', function ($injector, $rootScope, $templateCache, $timeout, Format) {
        return {
            replace: true,
            transclude: true,
            template: function () {
                return $templateCache.get('templates/form-field/form-field.html');
            },
            controller: ['$scope', '$timeout', function($scope, $timeout) {
            }],
            compile: function (elem, attrs) {
                return {
                    pre: function (scope, elem, attrs, ctrl) {
                        scope.optionsLoaded = false;
                        scope.dirOptions = [];

                        // strings
                        if (!scope.directiveAttributes.name) { scope.name = 'field'; }
                        if (!scope.directiveAttributes.id) { scope.id = scope.name; }
                        if (!scope.directiveAttributes.label) { scope.label = Format.label(scope.name); }
                        scope.$evalAsync(function () {
                            if (!scope.directiveAttributes.requiredText) { scope.requiredText = 'Please enter a ' + Format.label((scope.label || scope.name)); }
                        });
                        if (!scope.directiveAttributes.blankText) { scope.blankText = 'Select ' + scope.label; } else { if (scope.blankText == 'EMPTY') { scope.blankText = ''; } else { scope.blankText = 'Select ' + scope.blankText; } }                        
                        if (!scope.directiveAttributes.method) { scope.method = 'get'; }
                        if (!scope.directiveAttributes.size) { scope.size = 35; }
                        if (!scope.directiveAttributes.placeholder) { scope.placeholder = ''; }

                        // bools
                        if (!scope.directiveAttributes.showLabel) { scope.showLabel = scope.label.length > 0; }
                        if (!scope.directiveAttributes.title) { scope.title = scope.label; }
                        if (!scope.directiveAttributes.showColon) { scope.showColon = true; }
                        if (!scope.directiveAttributes.showBlank) { scope.showBlank = true; }
                        if (!scope.directiveAttributes.setOptions) { scope.setOptions = true; }

                        /*scope.$evalAsync(function () {
                            //angular.element(elem[0]).on("focus", 'ng-form', function () {
                            //    var firstInvalid = elem[0].querySelector('input:not([type=hidden]), select:not([type=hidden])');
                            //    if (firstInvalid) {
                            //        firstInvalid.focus();
                            //    }
                            //});
                        });*/
                    },
                    post: function (scope, elem, attrs, ctrl) {

                        /*
                        scope.validationFocus = function () {
                            elem[0].querySelector('ng-form').focus = function () {
                                scope.firstInvalid = elem[0].querySelector('input:not([type=hidden]), select:not([type=hidden])');
                                if (scope.firstInvalid) {
                                    scope.firstInvalid.focus();
                                }
                            }
                        };

                        var validationFocusTimeout = $timeout(function () {
                            scope.validationFocus();
                        }, 0);
                        */

                        if (scope.options != null && !(scope.service != null && scope.service != '' && scope.serviceOverride)) {
                            if (Object.prototype.toString.call(scope.options) !== '[object Array]') {
                                scope.options.split(',').forEach(function (option) {
                                    scope.dirOptions.push({ id: option.trim(), name: option.trim() });
                                });
                                scope.optionsLoaded = true;
                            }
                            else {
                                scope.$evalAsync(function () {
                                    scope.dirOptions = scope.options;
                                    scope.optionsLoaded = true;
                                });
                            }
                        }
                        else if (scope.service != null && scope.service != '') {
                            var service = $injector.get(scope.service);

                            if (typeof (scope.parameters) == 'undefined' && scope.parameters == null) {
                                scope.parameters = {};
                            }
                            service[scope.method](angular.copy(scope.parameters)).then(function (data) {
                                scope.dirOptions = data;
                                scope.optionsLoaded = true;
                                if (scope.setOptions) {
                                    scope.options = data;
                                }
                            });
                        }
                        else {
                            scope.optionsLoaded = true;
                        }

                        // watch if options is coming from an array that hasn't been set yet
                        scope.$watch('options', function (options) {
                            if (options != null && scope.optionsLoaded) {
                                scope.optionsLoaded = false;
                                scope.dirOptions = [];

                                if (Object.prototype.toString.call(scope.options) !== '[object Array]') {
                                    scope.options.split(',').forEach(function (option) {
                                        scope.dirOptions.push({ id: option.trim(), name: option.trim() });
                                    });
                                }
                                else {
                                    scope.dirOptions = scope.options;
                                }
                                scope.optionsLoaded = true;
                            }
                        }, true);

                        scope.getDescendantProp = function (obj, desc) {
                            return Format.getDescendantProp(obj, desc, scope.forceString);
                        }

                        scope.$on('$destroy', function () {
                            // $timeout.cancel(validationFocusTimeout);

                            // scope.firstInvalid = undefined;
                            // elem[0].querySelector('ng-form').focus = undefined;
                        });
                	}
            	}
            }
        };
    }])

;